import type { CSSProperties, ReactNode } from "react";

/**
 * Kit-wide JSON emphasis convention (ADR-0076): configs pass plain strings plus
 * an optional `…Emphasis` substring; the first occurrence is wrapped in the
 * accent tag (`<i>` — lime italic in the premium CSS — or `<b>`). TSX callers
 * may still pass a ReactNode, which is returned untouched. Same contract as the
 * `title`/`titleEmphasis` pair on `KitHeroSimple` — no HTML in JSON.
 * The optional `style` escape hatch covers the rare accent that needs an
 * inline color override outside a `.dark`/`.cross-dark` ancestor (e.g.
 * `GuidePains`' lime title on a section that isn't itself `.dark`).
 */
export function renderEmphasis(
  text: ReactNode,
  emphasis: string | undefined,
  Tag: "i" | "b" | "span" = "i",
  className?: string,
  style?: CSSProperties,
): ReactNode {
  if (typeof text !== "string" || !emphasis) return text;
  const at = text.indexOf(emphasis);
  if (at === -1) return text;
  return (
    <>
      {text.slice(0, at)}
      <Tag className={className} style={style}>
        {emphasis}
      </Tag>
      {text.slice(at + emphasis.length)}
    </>
  );
}
